module.exports = __webpack_public_path__ + "img/into.854db00d.png";